export default {
  serverUrl: 'https://mc.test.portal.nkgbloom.coffee'
}
